import { Button, themeConWeb } from '@foodsby/nutrient'
import React, { Fragment } from 'react'
import { connect } from 'react-redux'

import { loadLocationStart } from '../../redux/modules/location'
import { selectCurrentLocationWithAddress } from '../../redux/modules/selectors'
import { pushGTMDataLayer } from '../../util/gtmUtils'
import { pushSnowplow, toSignupProcessSchema } from '../../util/snowplow'
import CollectEmailPanel from '../home/CollectEmailPanel'
import LoginFormContainer from './LoginFormContainer'

const styles = {
  Icon: {
    fontSize: '48px',
    position: 'relative',
    top: '12px',
  },
  Join: {
    padding: '32px',
  },
  LargeIcon: {
    fontSize: '72px',
  },
  Login: {
    padding: '32px',
  },
  Signup: {
    fontSize: '20px',
  },
}

const Login = ({ loginTitle, path, signupMessage, toggleLoginAndJoin, toggleVisibility }) => {
  return (
    <div className="row" data-gtm-elm-id="LoginOrJoinModal">
      <div className="col-xs-12 col-md-6 first-panel" style={styles.Login}>
        <h2 className="title" style={{ marginBottom: '24px', textAlign: 'center' }}>
          {loginTitle}
        </h2>
        <LoginFormContainer path={path} toggleVisibility={toggleVisibility} />
      </div>
      <div className="col-xs-12 col-md-6 center-xs second-panel" style={styles.Login}>
        <h2 className="title" style={{ marginBottom: '24px' }}>
          {window.appboy ? 'Get free delivery on your first order!' : `Don't Have an Account?`}
        </h2>
        <p style={styles.Signup}>{signupMessage}</p>
        <p style={styles.LargeIcon}>
          <i className="icon-user" style={{ color: themeConWeb.color.greyShade3 }} />
        </p>
        <div>
          <Button
            className="secondary"
            onClick={() => {
              toggleLoginAndJoin()
              pushSnowplow(toSignupProcessSchema('sign_in', 'user_switch_to_sign_up'))
            }}
          >
            Create An Account
          </Button>
        </div>
      </div>
    </div>
  )
}

const Join = ({ joinTitle, locationId, loginMessage, path, toggleLoginAndJoin }) => (
  <div className="row">
    <div className="col-xs-12 col-md-6 center-xs first-panel" style={styles.Join}>
      <h2 className="title" style={{ marginBottom: '24px' }}>
        Already Signed Up?
      </h2>
      <p style={styles.Signup}>{loginMessage}</p>
      <p style={styles.LargeIcon}>
        <i className="icon-user" style={{ color: themeConWeb.color.greyShade3 }} />
      </p>
      <div>
        <Button
          className="secondary"
          onClick={() => {
            toggleLoginAndJoin()
            pushSnowplow(toSignupProcessSchema('sign_up', 'user_switch_to_sign_in'))
          }}
        >
          Login Now
        </Button>
      </div>
    </div>
    <div
      className="col-xs-12 col-md-6 second-panel"
      dtat-gtm-elm-id="JoinPanel"
      style={styles.Join}
    >
      <h2 className="title" style={{ marginBottom: '4px' }}>
        {joinTitle}
      </h2>
      <CollectEmailPanel locationId={locationId} path={path} />
    </div>
  </div>
)

class LoginOrJoin extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      showLogin: true,
    }
    pushGTMDataLayer({ event: 'optimize.activate' })
  }

  toggleLoginAndJoin = () => {
    this.setState({
      showLogin: !this.state.showLogin,
    })
  }

  render() {
    const { dropoffId, locationId, toggleVisibility, ...rest } = this.props
    const { showLogin } = this.state
    return (
      <Fragment>
        {showLogin ? (
          <Login
            dropoffId={dropoffId}
            locationId={locationId}
            toggleLoginAndJoin={this.toggleLoginAndJoin}
            toggleVisibility={toggleVisibility}
            {...rest}
          />
        ) : (
          <Join
            dropoffId={dropoffId}
            locationId={locationId}
            toggleLoginAndJoin={this.toggleLoginAndJoin}
            {...rest}
          />
        )}
      </Fragment>
    )
  }
}

const mapStateToProps = state => {
  const location = selectCurrentLocationWithAddress(state)
  return {
    location,
  }
}

const mapDispatchToProps = {
  loadLocationStart,
}

export default connect(mapStateToProps, mapDispatchToProps)(LoginOrJoin)
